import React, { Component } from "react";
import { Container } from "reactstrap";
import { RouterProps } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ComisionesManualesAdmin.form";
import { MemoTable } from "./ComisionesManualesAdmin.table";
import { ComisionesManualesAdminDispatcher } from "../../../containers/comisionesManuales/administracion/ComisionesManualesAdmin.dispatcher";
import { ComisionesManualesAdminStore } from "../../../containers/comisionesManuales/administracion/ComisionesManualesAdmin.store";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import {
  deleteFormConfig,
  Inputs as DeleteInputs
} from "./ComisionesManualesAdminBorrar.form";

interface Props
  extends ComisionesManualesAdminDispatcher,
    ComisionesManualesAdminStore,
    RouterProps {}

interface State {
  filters: {
    fechaPago: string | null;
  };
  showDeleteModal: boolean;
  comisionToDelete: number | null;
  noConfirmarMas: boolean;
}

export default class ComisionesManualesAdminComponent extends Component<
  Props,
  State
> {
  state = {
    filters: {
      fechaPago: null
    },
    showDeleteModal: false,
    comisionToDelete: null,
    noConfirmarMas: false
  };

  componentDidMount(): void {
    this.props.clearComisionesManualExtras();
  }

  submit = async (data: { [key in Inputs]: any }) => {
    if (!data.fechaPago) {
      errorNotification("Debe seleccionar una quincena");
      return;
    }

    this.setState({
      filters: {
        fechaPago: data.fechaPago
      }
    });

    const preview = await this.props.getComisionesManualExtras(data.fechaPago);

    if (preview.fulfilled && preview.comisionesManualExtras.length > 0) {
      successNotification("Comisiones cargadas correctamente.");
    } else if (preview.fulfilled) {
      errorNotification(
        "No se encontraron comisiones para la quincena seleccionada."
      );
    } else {
      errorNotification(preview.gettingComisionesManualExtrasError);
    }
  };

  handleDelete = (id: number) => {
    if (this.state.noConfirmarMas) {
      this.confirmDelete(id);
    } else {
      this.setState({
        showDeleteModal: true,
        comisionToDelete: id
      });
    }
  };

  confirmDelete = async (id?: number) => {
    const comisionId = id || this.state.comisionToDelete;
    if (!comisionId) return;

    const preview = await this.props.deleteComisionManual(comisionId, () => {
      // Recargar la lista después de eliminar
      if (this.state.filters.fechaPago) {
        this.props.getComisionesManualExtras(this.state.filters.fechaPago);
      }
    });

    if (!preview.fulfilled) {
      errorNotification(preview.deletingComisionManualError);
    }

    this.setState({
      showDeleteModal: false,
      comisionToDelete: null
    });
  };

  handleModalSubmit = (values: { [key in DeleteInputs]: any }) => {
    if (values.noConfirmarMas) {
      this.setState({ noConfirmarMas: true });
    }
    this.confirmDelete();
  };

  handleModalCancel = () => {
    this.setState({
      showDeleteModal: false,
      comisionToDelete: null
    });
  };

  render() {
    const {
      comisionesManualExtras,
      gettingComisionesManualExtras,
      deletingComisionManual
    } = this.props;

    return (
      <Container>
        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={gettingComisionesManualExtras}
          />
        </div>

        {comisionesManualExtras && comisionesManualExtras.length > 0 && (
          <MemoTable
            comisiones={comisionesManualExtras}
            loading={gettingComisionesManualExtras}
            onDelete={this.handleDelete}
            deleting={deletingComisionManual}
          />
        )}

        <FormBuilderModal
          isOpen={this.state.showDeleteModal}
          title="Confirmar eliminación"
          message="¿Está seguro de eliminar esta comisión? Esta acción no se puede deshacer."
          ok={this.handleModalSubmit}
          cancel={this.handleModalCancel}
          formConfig={deleteFormConfig}
          size="md"
        />

        <div style={{ height: "64px" }}></div>
      </Container>
    );
  }
}
